import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';

// Numero di footer #otp_cf{n}# presenti nel PDF, uno per ogni chiamata F(n).
// Non va ricavato da countPdfPages: se una pagina trabocca le pagine fisiche
// aumentano ma le ancore no, e chiedere a OTP un'ancora inesistente dà 422.
// Aggiornarlo se si aggiunge o toglie una pagina con F(n).
export const CONSULENZA_FOOTER_PAGES = 8;

const C = {
    black:         '#1a1a1a',
    darkGray:      '#333333',
    midGray:       '#666666',
    silver:        '#cccccc',
    accent:        '#8b0000',
    headerBg:      '#1c2b4a',
    sectionBg:     '#dde3ec',
    sectionBorder: '#1c2b4a',
    fieldLine:     '#888888',
    white:         '#ffffff',
    sigBorder:     '#d32f2f', // bordo rosso dei riquadri firma del Mandante (come MandatoPDF/BonificaPDF)
};

const styles = StyleSheet.create({
    page: {
        fontSize: 9.5,
        fontFamily: 'Times-Roman',
        lineHeight: 1.5,
        color: C.black,
    },
    header: {
        paddingTop: 0,
        paddingBottom: 4,
        paddingHorizontal: 35,
    },
    headerBanner:       { width: '100%', height: 75, objectFit: 'contain' },
    headerInner:        { flexDirection: 'row', alignItems: 'center', paddingTop: 10, paddingBottom: 6 },
    logo:               { width: 55, height: 45, objectFit: 'contain' },
    headerTextBlock:    { flex: 1, paddingLeft: 10 },
    headerAgency:       { fontSize: 12, fontFamily: 'Times-Roman', color: C.black, letterSpacing: 0.3 },
    headerSub:          { fontSize: 7.5, color: C.midGray, marginTop: 1 },
    headerAccentBar:    { height: 2, backgroundColor: C.accent },
    headerMeta:         { flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 35, paddingTop: 3, paddingBottom: 3, borderTopWidth: 0.5, borderTopColor: C.silver },
    headerConfidential: { fontSize: 7, color: C.midGray, fontStyle: 'italic', letterSpacing: 0.5 },
    headerPageNum:      { fontSize: 7, color: C.midGray, textAlign: 'right' },

    footer:               { marginTop: 'auto', borderTopWidth: 0.5, borderTopColor: C.silver, paddingHorizontal: 35, paddingVertical: 5, flexDirection: 'row', alignItems: 'flex-end', justifyContent: 'space-between' },
    footerBanner:         { width: '100%', height: 35, objectFit: 'contain', marginBottom: 4 },
    footerRow:            { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
    footerSignBlock:      { flexDirection: 'row', alignItems: 'center' },
    footerArrow:          { fontSize: 10, color: C.accent, marginRight: 4 },
    footerLabel:          { fontSize: 8, color: C.darkGray, borderBottomWidth: 0.5, borderBottomColor: C.darkGray, borderBottomStyle: 'dotted', paddingBottom: 1, minWidth: 130 },
    footerPageCenter:     { fontSize: 8, color: C.midGray, textAlign: 'center' },
    footerCopyright:      { fontSize: 6, color: C.midGray, fontStyle: 'italic', flex: 1 },
    footerSignature:      { flexDirection: 'column', alignItems: 'flex-start', marginLeft: 16, minWidth: 130 },
    footerSignatureLabel: { fontSize: 7, color: C.midGray, marginBottom: 3 },
    footerSignatureLine:  { width: 130, height: 24, borderWidth: 0.75, borderColor: C.sigBorder, backgroundColor: '#fafafa' },

    docTitleBar: {
        borderWidth: 1, borderColor: C.sectionBorder,
        paddingVertical: 6, paddingHorizontal: 12, marginBottom: 10, marginTop: 4,
    },
    docTitleMain: {
        fontSize: 12, fontFamily: 'Times-Roman', textAlign: 'center', color: C.headerBg, letterSpacing: 0.5,
    },

    sectionTitle: {
        backgroundColor: C.sectionBg, borderLeftWidth: 3, borderLeftColor: C.sectionBorder,
        paddingVertical: 4, paddingHorizontal: 8, marginTop: 10, marginBottom: 6,
        fontSize: 9, fontFamily: 'Times-Roman', color: C.headerBg, letterSpacing: 0.3, textTransform: 'uppercase',
    },

    fieldRow:       { flexDirection: 'row', alignItems: 'flex-end', marginBottom: 5 },
    fieldLabel:     { fontFamily: 'Times-Roman', fontSize: 9, color: C.darkGray, marginRight: 5, whiteSpace: 'nowrap' },
    fieldValue:     { flex: 1, borderBottomWidth: 0.75, borderBottomColor: C.fieldLine, fontSize: 9.5, paddingBottom: 2, minHeight: 14, color: C.black },
    fieldLabelBold: { fontFamily: 'Times-Roman', fontSize: 10, color: C.black, marginBottom: 2 },

    checkRow:     { flexDirection: 'row', alignItems: 'center', marginBottom: 4 },
    checkbox:     { width: 11, height: 11, borderWidth: 1, borderColor: C.darkGray, borderRadius: 1, marginRight: 6, alignItems: 'center', justifyContent: 'center', backgroundColor: C.white },
    checkboxTick: { fontSize: 8, color: C.accent, lineHeight: 1 },
    checkLabel:   { fontSize: 9.5, color: C.black, flex: 1 },

    textBox:        { borderWidth: 0.75, borderColor: C.silver, backgroundColor: '#fafafa', minHeight: 70, marginBottom: 6, padding: 5 },
    textBoxContent: { fontSize: 9.5, color: C.black },

    para:      { marginBottom: 5, textAlign: 'justify', fontSize: 9.5, lineHeight: 1.5 },
    paraSmall: { marginBottom: 4, textAlign: 'justify', fontSize: 9, lineHeight: 1.5 },

    compensoBox: {
        borderWidth: 1, borderColor: C.fieldLine, paddingHorizontal: 12, paddingVertical: 8,
        minWidth: 200, minHeight: 30, alignSelf: 'flex-start', marginBottom: 6, marginTop: 2,
    },

    signatureSection:  { marginTop: 20, marginBottom: 10 },
    signatureLabel:    { fontSize: 10, fontStyle: 'italic', color: C.midGray, textAlign: 'left', marginBottom: 4 },
    signatureArrowRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' },
    signatureArrow:    { fontSize: 13, color: C.accent, marginRight: 6 },
    signatureLine:     { flex: 1, borderWidth: 0.75, borderColor: C.sigBorder, backgroundColor: '#fafafa', height: 60 },

    divider: { borderTopWidth: 0.5, borderTopColor: C.silver, marginVertical: 6 },
});

/* Helpers */

const SectionTitle = ({ children }: { children: React.ReactNode }) => (
    <Text style={styles.sectionTitle}>{children}</Text>
);

const Para = ({ children, bold, style }: any) => (
    <Text style={[styles.para, bold ? { fontFamily: 'Times-Roman' } : {}, style]}>
        {children}
    </Text>
);

const B = ({ children }: { children: any }) => (
    <Text style={{ fontFamily: 'Times-Roman' }}>{children}</Text>
);

const BulletItem = ({ children }: { children: any }) => (
    <View style={{ flexDirection: 'row', marginBottom: 4, paddingLeft: 6 }}>
        <Text style={{ fontSize: 9.5, marginRight: 6, lineHeight: 1.5 }}>-</Text>
        <Text style={{ flex: 1, fontSize: 9.5, lineHeight: 1.5, textAlign: 'justify' }}>{children}</Text>
    </View>
);

const CheckItem = ({ checked, label }: { checked?: boolean; label: any }) => (
    <View style={[styles.checkRow, { paddingLeft: 10 }]}>
        <View style={styles.checkbox}>
            {checked && <View style={{ width: 7, height: 7, backgroundColor: C.accent }} />}
        </View>
        <Text style={styles.checkLabel}>{label}</Text>
    </View>
);

/* Header */
const isSupportedImageUrl = (url?: string) =>
    !!url && !url.startsWith('data:image/svg');

const PageHeader = ({ settings, data }: any) => {
    const rawBanner  = settings?.mandatoHeaderUrl || settings?.mandatoHeaderImageUrl || settings?.reportHeaderUrl;
    console.log(rawBanner)
    const bannerUrl  = isSupportedImageUrl(rawBanner) ? rawBanner : undefined;
    const rawLogo    = settings?.logoUrl || data?.logoUrl;
    const logoUrl    = isSupportedImageUrl(rawLogo) ? rawLogo : undefined;
    const agencyName = settings?.agencyName || data?.nome_azienda || '';
    return (
        <View style={styles.header}>
            {bannerUrl ? (
                <Image src={bannerUrl} style={styles.headerBanner} />
            ) : (
                <View style={styles.headerInner}>
                    {logoUrl && <Image src={logoUrl} style={styles.logo} />}
                    <View style={styles.headerTextBlock}>
                        <Text style={styles.headerAgency}>{agencyName}</Text>
                        <Text style={styles.headerSub}>Investigazioni Private · Sicurezza · Consulenza</Text>
                    </View>
                </View>
            )}
            <View style={styles.headerAccentBar} />
            <View style={styles.headerMeta}>
                <Text style={styles.headerPageNum}
                      render={({ pageNumber, totalPages }) => `Pag. ${pageNumber} di ${totalPages}`} />
            </View>
        </View>
    );
};

/* Footer */
const PageFooter = ({ pageNum }: { pageNum: number }) => (
    <View style={styles.footer}>
        <Text style={styles.footerCopyright}>
            Il presente documento costituisce opera dell'ingegno ai sensi della normativa vigente ed è riservato all'uso esclusivo dei soggetti espressamente autorizzati dall'autore.
        </Text>
        <View style={styles.footerSignature}>
            <Text style={styles.footerSignatureLabel}>Firma Mandante:</Text>
            <View style={styles.footerSignatureLine}>
                <Text style={{ fontSize: 0.01, color: '#ffffff' }}>{`#otp_cf${pageNum}#`}</Text>
            </View>
        </View>
    </View>
);

/* Documento */

export const ConsulenzaPDF = ({ data }: { data: any }) => {
    const { cliente, pratica, settings } = data;
    // Modulo in bianco da compilare a penna: nessuna casella spuntata in automatico.
    const inBianco = !!data.inBianco;
    const safeSettings = settings || {};
    const nomeAzienda  = safeSettings?.agencyName || data.nome_azienda || '';

    console.group('%c[ConsulenzaPDF] DEBUG nome agenzia', 'background:#1c2b4a;color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold;');
    console.log('🔍 data ricevuto:', data);
    console.log('🔍 data ha keys:', data ? Object.keys(data) : 'data=null/undefined');
    console.log('---');
    console.log('🏢 settings (raw):', settings);
    console.log('🏢 typeof settings:', typeof settings);
    console.log('🏢 settings ha keys:', settings ? Object.keys(settings) : 'settings=null/undefined');
    console.log('🏢 safeSettings?.agencyName:', safeSettings?.agencyName, '(typeof:', typeof safeSettings?.agencyName, ')');
    console.log('🏢 data.nome_azienda:', data.nome_azienda, '(typeof:', typeof data.nome_azienda, ')');
    console.log('---');
    console.log('✅ nomeAzienda finale:', JSON.stringify(nomeAzienda), '| length:', nomeAzienda?.length, '| empty?', !nomeAzienda);
    console.log('---');
    console.log('👤 cliente:', cliente);
    console.log('📁 pratica:', pratica);
    console.log('--- immagini settings ---');
    console.log('logoUrl:',               safeSettings?.logoUrl);
    console.log('mandatoHeaderUrl:',      safeSettings?.mandatoHeaderUrl);
    console.log('mandatoHeaderImageUrl:', safeSettings?.mandatoHeaderImageUrl);
    console.log('reportHeaderUrl:',       safeSettings?.reportHeaderUrl);
    console.log('mandatoFooterUrl:',      safeSettings?.mandatoFooterUrl);
    console.log('mandatoFooterImageUrl:', safeSettings?.mandatoFooterImageUrl);
    console.log('reportFooterUrl:',       safeSettings?.reportFooterUrl);
    console.log('privacyPolicyUrl:',      safeSettings?.privacyPolicyUrl);
    console.groupEnd();

    if (!nomeAzienda) {
        console.warn('[ConsulenzaPDF] ⚠️ nomeAzienda VUOTO. Verificare:');
        console.warn('  • data.settings.agencyName arriva da globalSettings?');
        console.warn('  • data.nome_azienda viene impostato in buildPdfPayload?');
        console.warn('  • il payload passato a <ConsulenzaPDF data={...}/> è quello atteso?');
    }

    const isAzienda    = cliente?.tipo === 'Azienda';
    // Ripiego per le aziende registrate col vecchio modello (denominazioneTerzi / nome).
    const nomeMandante = isAzienda
        ? (cliente?.ragioneSociale || cliente?.denominazioneTerzi || cliente?.nome || '')
        : `${cliente?.nome || ''} ${cliente?.surname || ''}`.trim();

    const hasFooterImg = !!(safeSettings?.mandatoFooterUrl || safeSettings?.mandatoFooterImageUrl || safeSettings?.reportFooterUrl);
    console.log('[ConsulenzaPDF] hasFooterImg:', hasFooterImg, '| nomeMandante:', nomeMandante);

    /* La Page non ha padding perché header e footer assoluti arrivano ai bordi;
       lo spazio sotto l'header lo dà il paddingTop di contentStyle. */
    const pageStyle = styles.page;
    const cs = {
        paddingHorizontal: 35,
    };

    const H = () => <PageHeader settings={safeSettings} data={data} />;
    const F = (n: number) => <PageFooter pageNum={n} />;

    const rifStr = pratica?.rif_numero && !pratica.rif_numero.toLowerCase().startsWith('temp')
        ? pratica.rif_numero : '';

    const t = pratica || {};

    return (
        <Document>

            {/* Pagina 1 */}
            <Page size="A4" style={pageStyle}>
                {H()}
                <View style={cs}>

                    <View style={styles.docTitleBar}>
                        <Text style={styles.docTitleMain}>
                            INCARICO PER LO SVOLGIMENTO DI ATTIVITÀ DI CONSULENZA
                        </Text>
                    </View>

                    <View style={styles.fieldRow}>
                        <Text style={[styles.fieldLabelBold, { width: 120 }]}>Data Sottoscrizione</Text>
                        <Text style={[styles.fieldValue, { maxWidth: 120 }]}>{t.data_incarico || ''}</Text>
                        {rifStr ? (
                            <>
                                <Text style={[styles.fieldLabel, { marginLeft: 20 }]}>Rif. N°</Text>
                                <Text style={[styles.fieldValue, { maxWidth: 80 }]}>{rifStr}</Text>
                            </>
                        ) : null}
                    </View>

                    <View style={styles.fieldRow}>
                        <Text style={[styles.fieldLabelBold, { width: 120 }]}>Il/la Sottoscritto/a</Text>
                        <Text style={styles.fieldValue}>{nomeMandante}</Text>
                    </View>

                    {isAzienda ? (
                        <View style={styles.fieldRow}>
                            <Text style={styles.fieldLabel}>Partita IVA</Text>
                            <Text style={[styles.fieldValue, { flex: 1 }]}>{cliente?.partitaIva || ''}</Text>
                            <Text style={[styles.fieldLabel, { marginLeft: 10 }]}>Cod. SDI</Text>
                            <Text style={[styles.fieldValue, { flex: 0.6 }]}>{cliente?.codiceSdi || ''}</Text>
                        </View>
                    ) : (
                        <View style={styles.fieldRow}>
                            <Text style={styles.fieldLabel}>nato/a a</Text>
                            <Text style={[styles.fieldValue, { flex: 2 }]}>{cliente?.luogoNascita || ''}</Text>
                            <Text style={[styles.fieldLabel, { marginLeft: 10 }]}>in data</Text>
                            <Text style={[styles.fieldValue, { flex: 1 }]}>{cliente?.dataNascita || ''}</Text>
                        </View>
                    )}

                    <View style={styles.fieldRow}>
                        <Text style={styles.fieldLabel}>residente in via</Text>
                        <Text style={[styles.fieldValue, { flex: 2 }]}>{cliente?.indirizzo || ''}</Text>
                        <Text style={[styles.fieldLabel, { marginLeft: 10 }]}>C.A.P.</Text>
                        <Text style={[styles.fieldValue, { flex: 0.7 }]}>{cliente?.cap || ''}</Text>
                    </View>
                    <View style={styles.fieldRow}>
                        <Text style={styles.fieldLabel}>Comune:</Text>
                        <Text style={[styles.fieldValue, { flex: 2 }]}>{cliente?.citta || ''}</Text>
                        <Text style={[styles.fieldLabel, { marginLeft: 10 }]}>Prov.</Text>
                        <Text style={[styles.fieldValue, { flex: 0.5 }]}>{cliente?.provincia || ''}</Text>
                    </View>
                    {!isAzienda && (
                        <View style={styles.fieldRow}>
                            <Text style={styles.fieldLabel}>Codice Fiscale:</Text>
                            <Text style={styles.fieldValue}>{cliente?.codiceFiscale || ''}</Text>
                        </View>
                    )}
                    <View style={styles.fieldRow}>
                        <Text style={styles.fieldLabel}>Identificato tramite documento</Text>
                        <Text style={[styles.fieldValue, { flex: 1.5 }]}>{cliente?.docTipo || ''}</Text>
                        <Text style={[styles.fieldLabel, { marginLeft: 10 }]}>n°</Text>
                        <Text style={[styles.fieldValue, { flex: 1 }]}>{cliente?.docNumero || ''}</Text>
                    </View>
                    <View style={styles.fieldRow}>
                        <Text style={styles.fieldLabel}>rilasciato il</Text>
                        <Text style={[styles.fieldValue, { flex: 1 }]}>{cliente?.docDataRilascio || ''}</Text>
                        <Text style={[styles.fieldLabel, { marginLeft: 10 }]}>da</Text>
                        <Text style={[styles.fieldValue, { flex: 2 }]}>{cliente?.docRilascioDa || ''}</Text>
                    </View>

                    <Text style={[styles.fieldLabelBold, { marginTop: 6, marginBottom: 4 }]}>
                        che agisce in nome e per conto
                    </Text>
                    {/* Come in BonificaPDF: per un'azienda "per conto di" è l'azienda stessa,
                        con sede e PIVA dai campi nativi. */}
                    <View style={styles.checkRow}>
                        <View style={styles.checkbox}>
                            {!inBianco && !isAzienda && !cliente?.perContoDiTerzi && <View style={{ width: 7, height: 7, backgroundColor: C.accent }} />}
                        </View>
                        <Text style={[styles.checkLabel, { fontFamily: 'Times-Roman' }]}>PROPRIO</Text>
                    </View>
                    <View style={[styles.fieldRow, { alignItems: 'center', marginTop: 2 }]}>
                        <View style={styles.checkbox}>
                            {(isAzienda || cliente?.perContoDiTerzi) && <View style={{ width: 7, height: 7, backgroundColor: C.accent }} />}
                        </View>
                        <Text style={[styles.checkLabel, { marginRight: 6 }]}>di</Text>
                        <Text style={styles.fieldValue}>{
                            isAzienda
                                ? (cliente?.ragioneSociale || cliente?.denominazioneTerzi || cliente?.nome || '')
                                : (cliente?.denominazioneTerzi || '')
                        }</Text>
                    </View>

                    {(isAzienda || cliente?.perContoDiTerzi) ? (
                        <>
                            <View style={styles.fieldRow}>
                                <Text style={styles.fieldLabel}>con sede in via</Text>
                                <Text style={[styles.fieldValue, { flex: 2 }]}>{
                                    isAzienda ? (cliente?.indirizzo || cliente?.sedeTerzi || '') : (cliente?.sedeTerzi || '')
                                }</Text>
                                <Text style={[styles.fieldLabel, { marginLeft: 10 }]}>C.A.P.</Text>
                                <Text style={[styles.fieldValue, { flex: 0.7 }]}>{
                                    isAzienda ? (cliente?.cap || cliente?.capTerzi || '') : (cliente?.capTerzi || '')
                                }</Text>
                            </View>
                            <View style={styles.fieldRow}>
                                <Text style={styles.fieldLabel}>Comune:</Text>
                                <Text style={[styles.fieldValue, { flex: 2 }]}>{
                                    isAzienda ? (cliente?.citta || cliente?.comuneTerzi || '') : (cliente?.comuneTerzi || '')
                                }</Text>
                                <Text style={[styles.fieldLabel, { marginLeft: 10 }]}>Prov.</Text>
                                <Text style={[styles.fieldValue, { flex: 0.5 }]}>{
                                    isAzienda ? (cliente?.provincia || cliente?.provinciaTerzi || '') : (cliente?.provinciaTerzi || '')
                                }</Text>
                            </View>
                            <View style={styles.fieldRow}>
                                <Text style={styles.fieldLabel}>p. IVA/codice fiscale</Text>
                                <Text style={styles.fieldValue}>{
                                    isAzienda ? (cliente?.partitaIva || cliente?.pivaOrCfTerzi || '') : (cliente?.pivaOrCfTerzi || '')
                                }</Text>
                            </View>
                            <Para style={{ fontSize: 8.5, fontStyle: 'italic', color: C.midGray }}>
                                che rappresenta ai fini del presente mandato in qualità di Titolare, Legale Rappresentante o persona da questi all'uopo espressamente delegata, procuratore con delega del C.d.A., con pieni poteri per il presente atto,
                            </Para>
                        </>
                    ) : null}

                    <Para style={{ marginTop: 6 }}>di seguito denominato <B>"Mandante"</B>,</Para>
                    <Para bold>CONFERISCE INCARICO</Para>
                    <Para>a <B>{nomeAzienda}</B> di seguito <B>"Agenzia"</B>.</Para>

                    <View style={styles.divider} />
                    <Para bold style={{ fontStyle: 'italic' }}>PREMESSO CHE</Para>

                    <BulletItem>
                        il Mandante intende conferire incarico professionale per lo svolgimento di attività di consulenza tecnica, investigativa, criminologica, informatica, documentale, ricognitiva e/o di supporto all'accertamento di fatti e circostanze di proprio interesse;
                    </BulletItem>
                    <BulletItem>
                        il Mandante dichiara che l'incarico è richiesto per <B>finalità lecite, determinate e riconducibili alla tutela, verifica, ricostruzione, accertamento o difesa di un diritto o di un interesse giuridicamente rilevante</B>, anche in sede giudiziaria e/o stragiudiziale;
                    </BulletItem>
                    <BulletItem>
                        l'Agenzia è soggetto professionalmente qualificato e dotato delle competenze necessarie allo svolgimento delle attività richieste, direttamente o mediante propri collaboratori, consulenti, tecnici o professionisti di fiducia;
                    </BulletItem>
                    <BulletItem>
                        le attività oggetto del presente incarico potranno avere natura tecnica, documentale, investigativa, criminologica, informatica, consulenziale o di supporto, secondo quanto specificato dal Mandante e secondo le modalità concretamente concordate;
                    </BulletItem>


                    <BulletItem>
                        resta espressamente inteso che <B>l'Agenzia non svolgerà attività vietate dalla legge</B>, né attività di intercettazione, captazione abusiva, accesso abusivo a sistemi informatici, controllo illecito di persone, acquisizione indebita di dati o documenti, né attività che comportino l'esercizio di pubblici poteri riservati all'Autorità Giudiziaria o alla Polizia Giudiziaria.
                    </BulletItem>

                </View>
                {F(1)}
            </Page>

            {/* Pagina 2 */}
            <Page size="A4" style={pageStyle}>
                {H()}
                <View style={cs}>
                    <SectionTitle>TIPOLOGIA DI ATTIVITÀ RICHIESTA</SectionTitle>

                    <Para>Il Mandante richiede lo svolgimento di una o più delle seguenti attività, da intendersi nei limiti di legge e secondo le modalità operative ritenute tecnicamente idonee dall'Agenzia:</Para>

                    <CheckItem checked={!!t.tipo_consulenza_investigativa}  label="consulenza tecnico-investigativa;" />
                    <CheckItem checked={!!t.tipo_criminologica}             label="consulenza criminologica, ricostruttiva, preventiva o di analisi del rischio;" />
                    <CheckItem checked={!!t.tipo_tecnica_parte}             label="consulenza tecnica di parte e/o supporto a legale, consulente, azienda o privato;" />
                    <CheckItem checked={!!t.tipo_indagine_aziendale}        label="consulenza preliminare finalizzata alla valutazione di fattibilità di un'indagine in ambito privato, familiare, personale o patrimoniale, nei limiti della licenza e della normativa applicabile;" />
                    {/* "Ambito aziendale" corrisponde al campo tipo_accertamenti_dipendenti dei moduli. */}
                    <CheckItem checked={!!t.tipo_accertamenti_dipendenti}   label="consulenza preliminare finalizzata alla valutazione di fattibilità di un'indagine in ambito aziendale, commerciale, assicurativo, difensivo o di tutela del patrimonio aziendale;" />
                    <CheckItem checked={!!t.tipo_analisi_documentale}       label="analisi documentale, analisi atti, ricostruzione cronologica dei fatti, verifica di incongruenze o anomalie;" />
                    <CheckItem checked={!!t.tipo_analisi_dati}              label="analisi, estrazione, acquisizione, recupero o organizzazione di dati da computer, smartphone, tablet, supporti digitali, archivi, e-mail o altri sistemi legittimamente disponibili;" />
                    <CheckItem checked={!!t.tipo_informatica_forense}       label="analisi informatica, informatica forense, copia tecnica, duplicazione, estrazione, preservazione o verifica di dati digitali;" />
                    <CheckItem checked={!!t.tipo_analisi_media}             label="analisi di fotografie, filmati, file audio, conversazioni, documenti, tabulati, log, messaggi, tracciati, report, flussi contabili o altri elementi forniti dal Mandante;" />
                    <CheckItem checked={!!t.tipo_sopralluogo}               label="sopralluogo tecnico, ricognizione, ispezione documentale o verifica di luoghi, beni, dispositivi, procedure o materiali legittimamente messi a disposizione;" />
                    <CheckItem checked={!!t.tipo_osint}                     label="attività OSINT, ricerca da fonti aperte, verifica reputazionale o raccolta di informazioni pubblicamente accessibili, nei limiti di legge;" />
                    <CheckItem checked={!!t.tipo_redazione_relazione}       label="redazione di relazione tecnica, parere, verbale, report riepilogativo o elaborato consulenziale;" />

                    <View style={[styles.checkRow, { paddingLeft: 10, alignItems: 'flex-start', marginTop: 2 }]}>
                        <View style={[styles.checkbox, { marginTop: 2 }]}>
                            {!!t.tipo_altra_attivita && <View style={{ width: 7, height: 7, backgroundColor: C.accent }} />}
                        </View>
                        <View style={{ flex: 1 }}>
                            <Text style={{ fontSize: 9.5, color: C.black, marginBottom: 3 }}>altra attività:</Text>
                            <View style={[styles.textBox, { minHeight: 30 }]}>
                                <Text style={styles.textBoxContent}>{t.tipo_altra_attivita_testo || ''}</Text>
                            </View>
                        </View>
                    </View>


                    <SectionTitle>OGGETTO DELL'INCARICO</SectionTitle>

                    <Para bold>L'Agenzia è incaricata di eseguire le attività di seguito descritte:</Para>
                    <View style={styles.textBox}>
                        <Text style={styles.textBoxContent}>{t.oggetto_attivita || ''}</Text>
                    </View>
                    <Para style={{ fontSize: 8.5, fontStyle: 'italic', color: C.midGray }}>
                        I luoghi, i beni e i dispositivi oggetto dell'intervento potranno essere specificati, integrati o meglio individuati anche nel corso delle attività, su indicazione espressa richiesta del Mandante.
                    </Para>

                    <View style={[styles.fieldRow, { marginTop: 6 }]}>
                        <Text style={[styles.fieldLabelBold, { width: 180 }]}>Data e orario di inizio servizio:</Text>
                        <Text style={styles.fieldValue}>
                            {t.data_inizio_servizio
                                ? `${t.data_inizio_servizio}${t.orario_inizio_servizio ? `  –  Ore ${t.orario_inizio_servizio}` : ''}`
                                : ''}
                        </Text>
                    </View>
                    <View style={[styles.fieldRow, { marginTop: 2 }]}>
                        <Text style={[styles.fieldLabelBold, { width: 180 }]}>termine del servizio:</Text>
                        <Text style={styles.fieldValue}>{t.termine_servizio || ''}</Text>
                    </View>
                </View>
                {F(2)}
            </Page>

            {/* Pagina 3 */}
            <Page size="A4" style={pageStyle}>
                {H()}
                <View style={cs}>
                    <SectionTitle>FINALITÀ DICHIARATA E INTERESSE DEL MANDANTE</SectionTitle>

                    <Para>Il Mandante dichiara che la finalità dell'incarico è la seguente:</Para>

                    <CheckItem checked={!!t.finalita_diritto_giudiziario} label="tutela di un diritto in sede giudiziaria o stragiudiziale;" />
                    <CheckItem checked={!!t.finalita_patrimonio}          label="tutela del patrimonio personale, familiare o aziendale;" />
                    <CheckItem checked={!!t.finalita_verifica_fatti}      label="verifica, ricostruzione o documentazione di fatti rilevanti;" />
                    <CheckItem checked={!!t.finalita_supporto_legale}     label="supporto a legale, consulente tecnico, azienda, privato o professionista;" />
                    <CheckItem checked={!!t.finalita_prevenzione_rischio} label="prevenzione, gestione o valutazione di un rischio;" />

                    <View style={[styles.checkRow, { paddingLeft: 10, alignItems: 'flex-start', marginTop: 2 }]}>
                        <View style={[styles.checkbox, { marginTop: 2 }]}>
                            {!!t.finalita_altra && <View style={{ width: 7, height: 7, backgroundColor: C.accent }} />}
                        </View>
                        <View style={{ flex: 1 }}>
                            <Text style={{ fontSize: 9.5, color: C.black, marginBottom: 3 }}>altra finalità lecita:</Text>
                            <View style={[styles.textBox, { minHeight: 18 }]}>
                                <Text style={styles.textBoxContent}>{t.finalita_altra_testo || ''}</Text>
                            </View>
                        </View>
                    </View>

                    <Para style={{fontSize: 9.2}}>
                        Il Mandante dichiara che le informazioni richieste e le attività da svolgere sono <B>pertinenti, proporzionate e non eccedenti</B> rispetto alla finalità indicata.
                    </Para>


                    <SectionTitle>DICHIARAZIONE DI LEGITTIMA DISPONIBILITÀ, AUTORIZZAZIONE E MANLEVA</SectionTitle>

                    <Para>
                        Il Mandante <B>dichiara e garantisce</B>, sotto la propria <B>esclusiva responsabilità civile e penale</B>, di avere <B>piena e legittima disponibilità giuridica e materiale</B> dei luoghi, dei beni, dei documenti, dei dati, dei supporti informatici, degli account, degli archivi, dei dispositivi, delle credenziali o di ogni altro elemento oggetto del presente incarico, ovvero di essere munito di valido titolo, autorizzazione, delega o potere che consenta l'intervento richiesto.
                    </Para>
                    <Para>
                        La presente dichiarazione si intende riferita, a titolo esemplificativo e non esaustivo, a immobili, locali, uffici, veicoli, documenti, archivi cartacei o digitali, computer, notebook, smartphone, tablet, hard disk, server, supporti USB, memorie, caselle e-mail, account, sistemi digitali, fotografie, filmati, file audio, messaggi, conversazioni, dati contabili o aziendali, nonché ad ogni ulteriore bene, supporto o informazione consegnata o resa disponibile all'Agenzia.
                    </Para>
                    <Para>
                        Il Mandante <B>autorizza espressamente l'Agenzia e i suoi operatori, collaboratori o consulenti</B> all'accesso, all'esame, all'acquisizione tecnica, alla copia, alla verifica, all'elaborazione e all'analisi dei soli beni, dati, documenti, dispositivi e materiali legittimamente messi a disposizione per l'esecuzione dell'incarico.
                    </Para>
                    <Para>
                        Il Mandante <B>manleva e tiene indenne l'Agenzia</B> da qualsiasi conseguenza, contestazione, pretesa, azione, danno o responsabilità derivante da eventuali difetti di legittimazione, autorizzazione, disponibilità o titolarità dei luoghi, beni, dati, documenti, account, dispositivi, credenziali o materiali oggetto dell'attività richiesta.
                    </Para>

                    <SectionTitle>LIMITI DELL'INCARICO E ATTIVITÀ ESCLUSE</SectionTitle>

                    <Para style={{fontSize: 9.4}}>
                        Resta espressamente inteso che l'incarico sarà eseguito esclusivamente nei limiti consentiti dalla legge, dalla licenza eventualmente necessaria, dalle informazioni fornite e dalle autorizzazioni documentate dal Mandante.
                        Sono espressamente escluse, attività di intercettazione, captazione, registrazione abusiva, accesso abusivo a sistemi informatici o telematici, violazione di corrispondenza, installazione di software o apparati di controllo non autorizzati, acquisizione di credenziali altrui, accesso a profili social, e-mail, cloud, chat, dispositivi o archivi di terzi senza titolo, elusione di password, protezioni o sistemi di sicurezza in assenza di legittima autorizzazione, nonché qualunque attività diretta a ledere diritti di terzi o a realizzare finalità illecite.
                    </Para>
                    <Para style={{fontSize: 9.4}}>
                        L'Agenzia non assume incarichi aventi finalità meramente esplorative, emulative, persecutorie, diffamatorie, ricattatorie, discriminatorie o comunque non riconducibili a un interesse lecito, concreto e giuridicamente apprezzabile.
                        Qualora nel corso delle attività emergano elementi tali da rendere l'incarico non eseguibile, non conforme alla legge, non proporzionato o non coerente con quanto dichiarato dal Mandante, l'Agenzia potrà sospendere o interrompere l'attività, fermo restando il diritto al compenso e al rimborso delle spese maturate sino a quel momento.
                    </Para>

                </View>
                {F(3)}
            </Page>

            {/* Pagina 4 */}
            <Page size="A4" style={pageStyle}>
                {H()}
                <View style={cs}>

                    <SectionTitle>ATTIVITÀ IN AMBITO AZIENDALE, LAVORATIVO E TUTELA DEL PATRIMONIO</SectionTitle>

                    <Para>
                        Nel caso in cui l'incarico riguardi dipendenti, collaboratori, fornitori, soci, amministratori, clienti o altri soggetti collegati all'organizzazione aziendale del Mandante, il Mandante dichiara che l'attività è richiesta per <B>finalità lecite di tutela del patrimonio aziendale, difesa di diritti, verifica di condotte potenzialmente illecite o accertamento di fatti specifici</B> e non per il controllo generalizzato, indiscriminato o continuativo dell'ordinaria prestazione lavorativa.
                    </Para>
                    <Para>
                        L'Agenzia non installerà, attiverà o gestirà impianti audiovisivi, strumenti informatici, sistemi di geolocalizzazione, software, apparati o altri strumenti dai quali derivi controllo a distanza e generalizzato / indiscriminato dell'attività dei lavoratori, salvo che il Mandante documenti preventivamente il rispetto della normativa applicabile e delle eventuali autorizzazioni, accordi, informative o presupposti richiesti.
                    </Para>
                    <Para>
                        L'eventuale consegna o utilizzo di filmati, registrazioni, log, tracciati GPS, dati di accesso, sistemi aziendali, e-mail, chat, strumenti di lavoro o altri dati riferibili a lavoratori avviene sotto esclusiva responsabilità del Mandante, che dichiara di averli acquisiti, conservati e resi disponibili in modo lecito, proporzionato e conforme alla disciplina lavoristica e privacy applicabile.
                    </Para>
                    <Para>
                        L'Agenzia potrà rifiutare, sospendere o limitare le attività qualora ritenga che la richiesta presenti profili di rischio, sproporzione, difetto di legittimazione o possibile contrasto con la normativa vigente.
                    </Para>


                    <SectionTitle>CONSULENZA INFORMATICA, ESTRAZIONE DATI E SUPPORTI DIGITALI</SectionTitle>

                    <Para>
                        Nel caso in cui l'incarico riguardi computer, smartphone, tablet, supporti digitali, archivi informatici, sistemi aziendali, account, e-mail, chat, cloud o altri dispositivi elettronici, il Mandante dichiara di esserne proprietario, utilizzatore legittimo, amministratore autorizzato o comunque soggetto munito di valido titolo per richiederne l'esame, l'acquisizione, l'estrazione, il recupero o l'analisi dei dati.
                    </Para>
                    <Para>
                        Le attività potranno comprendere, a titolo esemplificativo, acquisizione tecnica, copia, duplicazione, estrazione, recupero dati, catalogazione, ricerca di file, analisi di metadati, verifica di log, organizzazione di evidenze digitali, redazione di report o relazione tecnica, nei limiti delle possibilità tecniche, della qualità dei supporti ricevuti e del titolo di legittima disponibilità dichiarato.
                    </Para>
                    <Para>
                        Il Mandante prende atto che l'eventuale fornitura di password, codici di accesso, credenziali, chiavi di cifratura o altri strumenti di accesso avviene sotto la sua esclusiva responsabilità e presuppone la piena legittimazione all'utilizzo degli stessi.
                    </Para>
                    <Para>
                        Salvo espressa pattuizione scritta, l'Agenzia non garantisce la realizzazione di una copia forense integrale, la recuperabilità dei dati cancellati, la piena leggibilità di supporti danneggiati, la conservazione di ogni metadato, né l'immutabilità tecnica di dispositivi e sistemi qualora il Mandante richieda attività meramente ricognitive, rapide o non forensi.
                    </Para>
                    <Para>
                        Ove necessario, i supporti consegnati potranno essere descritti in apposita scheda di presa in carico, con indicazione di tipologia, marca, modello, seriale, stato apparente, eventuali accessori, password fornite e modalità di restituzione.
                    </Para>

                </View>
                {F(4)}
            </Page>

            {/* Pagina 6 */}
            <Page size="A4" style={pageStyle}>
                {H()}
                <View style={cs}>
                    <SectionTitle>CONSULENZA CRIMINOLOGICA, TECNICA E DOCUMENTALE</SectionTitle>

                    <Para>
                        Nel caso in cui l'incarico abbia natura criminologica, ricostruttiva o tecnico-valutativa, l'attività potrà consistere nell'analisi di fatti, condotte, dinamiche, documenti, comunicazioni, contesti, profili di rischio, elementi comportamentali, scenari o criticità, con finalità di supporto consulenziale, preventivo, difensivo, strategico o di migliore comprensione dei fatti.
                    </Para>
                    <Para>
                        L'attività criminologica o consulenziale non costituisce diagnosi medica, psicologica o psichiatrica, né parere legale, fiscale, giuslavoristico o contabile, salvo espresso coinvolgimento di professionisti abilitati per le rispettive competenze.
                    </Para>
                    <Para>
                        Le valutazioni formulate dall'Agenzia avranno natura tecnica, ricognitiva e consulenziale, saranno basate sui materiali disponibili e sulle informazioni fornite dal Mandante, e non potranno essere intese come accertamento giudiziale definitivo di responsabilità, colpevolezza, attendibilità o verità storica dei fatti.
                    </Para>


                    <SectionTitle>DOCUMENTAZIONE, RELAZIONE E GESTIONE DEL MATERIALE</SectionTitle>

                    <Para>
                        L'Agenzia potrà documentare le attività svolte mediante annotazioni, fotografie, video, copie digitali, verbali, schede tecniche, report, relazioni, allegati o altri strumenti ritenuti utili alla corretta esecuzione dell'incarico.
                    </Para>
                    <Para>
                        La consegna di relazioni, report, elaborati, copie di dati, allegati o materiale documentale avverrà secondo le modalità concordate con il Mandante. Ove ritenuto opportuno, il materiale potrà essere consegnato in formato digitale protetto, cifrato o comunque idoneo a garantirne la riservatezza, con trasmissione separata delle credenziali di accesso.
                    </Para>
                    <Para>
                        Il Mandante prende atto che la relazione o il report eventualmente predisposti dall'Agenzia avranno contenuto tecnico, ricognitivo, consulenziale o investigativo, limitatamente a quanto effettivamente riscontrato, analizzato o documentato.
                    </Para>
                    <Para>
                        Il Mandante si impegna a <B>non alterare, manipolare, estrapolare in modo fuorviante, pubblicare, diffondere o utilizzare</B> il materiale ricevuto per finalità diverse da quelle dichiarate nel presente incarico, assumendosi ogni responsabilità per l'uso successivo dei report, delle immagini, dei video, dei dati, delle copie e degli allegati consegnati.
                    </Para>

                    <SectionTitle>RISERVATEZZA E TRATTAMENTO DEI DATI</SectionTitle>

                    <Para>
                        L'Agenzia tratterà le informazioni, i documenti, i dati personali e il materiale ricevuto o acquisito nell'ambito dell'incarico con criteri di riservatezza, proporzionalità, minimizzazione e sicurezza, limitando l'accesso ai soli soggetti autorizzati e ai collaboratori o consulenti eventualmente coinvolti per esigenze tecniche o operative.
                    </Para>
                    <Para>
                        Il Mandante prende atto che le attività potranno comportare il trattamento di dati personali, anche di terzi, nei limiti necessari all'esecuzione dell'incarico e alle finalità dichiarate.
                    </Para>
                    <Para>
                        Il Mandante si assume la responsabilità della liceità della comunicazione o consegna all'Agenzia dei dati, documenti e materiali forniti.
                    </Para>
                    <Para>
                        Salvo diverso accordo scritto, l'Agenzia potrà operare quale autonomo titolare del trattamento per le attività professionali, investigative e consulenziali rientranti nella propria autonomia organizzativa e valutativa; ove l'attività abbia natura meramente tecnica e sia svolta su istruzioni documentate del Mandante, le parti potranno regolare separatamente i rispettivi ruoli privacy.
                    </Para>
                    <Para>
                        Il Mandante dichiara di aver ricevuto idonea informativa ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679, ove applicabile, e di impegnarsi a fornire all'Agenzia ogni informazione necessaria alla corretta gestione del trattamento dei dati.
                    </Para>

                </View>
                {F(5)}
            </Page>

            {/* Pagina 8 */}
            <Page size="A4" style={pageStyle}>
                {H()}
                <View style={cs}>

                    <SectionTitle>RESPONSABILITÀ PER INTERVENTI TECNICI</SectionTitle>

                    <Para>
                        Il Mandante, <B>informato sulla natura delle attività e sugli eventuali interventi tecnici necessari a garantirne l'efficacia</B>, si assume ogni responsabilità civile, penale e patrimoniale correlata o conseguente all'intervento richiesto, ivi compresi eventuali danni derivanti o connessi alle operazioni concordate, quali, a titolo esemplificativo e non esaustivo, movimentazione di beni, accesso a locali, smontaggi, collegamenti, acquisizioni tecniche, copie, estrazioni, scansioni, verifiche su dispositivi, supporti informatici o sistemi digitali.
                    </Para>
                    <Para>
                        L'Agenzia opererà con la diligenza professionale richiesta dalla natura dell'incarico, restando esclusa ogni garanzia di risultato, recupero integrale di dati, individuazione certa di elementi, utilizzabilità processuale automatica del materiale, ottenimento di prove favorevoli o esito positivo di eventuali procedimenti, trattative, vertenze o iniziative del Mandante.
                    </Para>

                    <SectionTitle>ULTERIORI DICHIARAZIONI DEL MANDANTE</SectionTitle>

                    <Para style={{ marginBottom: 2 }}>Ai fini del presente incarico, il Mandante dichiara:</Para>

                    <BulletItem>
                        che tutte le dichiarazioni rese nel presente atto sono veritiere e rese sotto la propria esclusiva responsabilità civile e penale, consapevole che, in caso di dichiarazioni false, mendaci, reticenti o incomplete, potranno derivarne le conseguenze previste dalla legge e dal presente incarico.
                    </BulletItem>
                    <BulletItem>di avere un interesse concreto, attuale e legittimo allo svolgimento delle attività richieste;</BulletItem>
                    <BulletItem>di non richiedere all'Agenzia attività vietate dalla legge o comunque finalizzate a ledere diritti di terzi;</BulletItem>
                    <BulletItem>di non utilizzare le attività richieste per finalità illecite, persecutorie, diffamatorie, ricattatorie, discriminatorie o comunque estranee a quelle dichiarate;</BulletItem>
                    <BulletItem>di assumersi ogni responsabilità circa la veridicità, completezza e liceità delle informazioni, dei documenti, dei dati, delle credenziali, dei dispositivi e dei materiali forniti;</BulletItem>
                    <BulletItem>di impegnarsi a comunicare tempestivamente all'Agenzia ogni elemento utile o variazione rilevante ai fini del corretto svolgimento delle attività;</BulletItem>
                    <BulletItem>di prendere atto che, qualora emergano elementi in contrasto con quanto dichiarato, l'Agenzia potrà sospendere o risolvere l'incarico e rivalersi per eventuali danni subiti.</BulletItem>


                    <SectionTitle>RINVENIMENTO DI DISPOSITIVI DI SPIONAGGIO ELETTRONICO</SectionTitle>

                    <Para>
                        Resta espressamente inteso che, in caso di rinvenimento di dispositivi, apparati o sistemi non autorizzati di spionaggio elettronico, siano essi di natura audio, video, audio/video, radiotrasmittente, informatica o digitale (ivi compresi, a titolo esemplificativo e non esaustivo, tutti i dispositivi elettronici e informatici idonei alla captazione, registrazione, trasmissione o sottrazione di dati e informazioni), <B>l'attività dell'Agenzia si limiterà esclusivamente alla loro individuazione, identificazione ed eventuale classificazione</B>.
                    </Para>
                    <Para bold>
                        È espressamente esclusa qualsiasi attività di rimozione, manomissione o gestione materiale dei dispositivi rinvenuti da parte dell'Agenzia o dei suoi operatori tecnici.
                    </Para>
                    <Para>
                        La <B>rimozione, la custodia e la successiva gestione dei dispositivi</B> resteranno a <B>esclusivo carico del Mandante</B>, che vi provvederà autonomamente e non in presenza degli operatori dell'Agenzia, al fine di consentirne l'eventuale consegna all'Autorità Giudiziaria territorialmente competente quali allegati a esposto, denuncia e/o querela contro ignoti, unitamente agli esiti dell'attività di bonifica.
                    </Para>
                    <Para>
                        Il Mandante <B>manleva sin d'ora l'Agenzia da ogni responsabilità</B> connessa alla rimozione, conservazione, utilizzo o destinazione dei dispositivi rinvenuti, nonché da qualsiasi conseguenza derivante da iniziative assunte dal Mandante stesso successivamente al rinvenimento.
                    </Para>

                </View>
                {F(6)}
            </Page>

            {/* Pagina 9 */}
            <Page size="A4" style={pageStyle}>
                {H()}
                <View style={cs}>
                    <SectionTitle>ULTERIORI DICHIARAZIONI DEL MANDANTE</SectionTitle>

                    <Para>
                        Ai fini del presente mandato, il Mandante dichiara che tutte le dichiarazioni rese nel presente atto sono veritiere, rese sotto la propria esclusiva responsabilità civile e penale, consapevole che, in caso di dichiarazioni false, mendaci o reticenti, trovano applicazione le sanzioni di cui agli artt. 75 e 76 del D.P.R. 28 dicembre 2000 n. 445.
                    </Para>
                    <Para style={{ marginBottom: 2 }}>Il Mandante dichiara inoltre:</Para>

                    <BulletItem>di non essere a conoscenza di procedimenti giudiziari in corso nei propri confronti;</BulletItem>
                    <BulletItem>di non essere sottoposto ad indagini o accertamenti da parte dell'Autorità Giudiziaria o di Polizia Giudiziaria;</BulletItem>
                    <BulletItem>di non essere iscritto nel registro degli indagati;</BulletItem>
                    <BulletItem>di non aver ricevuto, negli ultimi 18 mesi, perquisizioni, ispezioni o informazioni di garanzia;</BulletItem>
                    <BulletItem>dichiara di aver letto, compreso e accettato integralmente il contenuto del presente atto;</BulletItem>


                    <BulletItem>dichiara di aver ricevuto idonea informativa privacy, ove applicabile;</BulletItem>
                    <BulletItem>dichiara di essere a conoscenza e di accettare che <B>l'obbligazione assunta dall'Agenzia è di mezzi e non di risultato</B> e che qualsiasi eventuale responsabilità è limitata, nei limiti consentiti dalla legge, all'importo del corrispettivo già pagato;</BulletItem>
                    <BulletItem>prende atto che, qualora il titolare e/o i collaboratori dell'Agenzia fossero chiamati dall'Autorità Giudiziaria a deporre in qualità di testi o a partecipare ad attività difensive, tecniche, giudiziarie o stragiudiziali, <B>gli onorari e le spese saranno a carico del Mandante</B> secondo il tariffario dell'Agenzia;</BulletItem>
                    <BulletItem>autorizza l'Agenzia ad avvalersi, a proprio insindacabile giudizio, di collaboratori esterni, consulenti, tecnici, professionisti e/o istituti corrispondenti, anche esteri, ove necessario per l'esecuzione dell'incarico;</BulletItem>
                    <BulletItem>si assume ogni responsabilità circa la veridicità delle affermazioni rese, la liceità delle finalità dell'incarico e l'utilizzo successivo del materiale consegnato dall'Agenzia.</BulletItem>

                    <Para style={{ marginTop: 4 }}>
                        Il Mandante <B>si impegna a comunicare tempestivamente all'Agenzia ogni elemento utile o variazione rilevante</B> ai fini del corretto svolgimento delle attività.
                    </Para>

                    <SectionTitle>COMPENSO E SPESE</SectionTitle>

                    <Para>Il compenso concordato per le attività oggetto del presente mandato è pari a</Para>
                    <View style={styles.compensoBox}>
                        <Text style={{ fontSize: 13, fontFamily: 'Times-Roman' }}>
                            {t.compenso_concordato ? `€  ${t.compenso_concordato}  + IVA` : '€  _____________________  + IVA'}
                        </Text>
                    </View>
                    <Para>
                        oltre alle <B>spese vive sostenute e documentate a piè di lista</B>, che il Mandante si impegna a rimborsare integralmente.
                    </Para>
                    <Para>
                        Il Mandante prende atto e accetta che il corrispettivo sopra indicato è determinato in conformità alle condizioni economiche pattuite, al tariffario in uso presso l'Agenzia, nonché alle attività effettivamente svolte, anche su base oraria e/o a consuntivo, in relazione al tempo impiegato, alle risorse utilizzate e alla complessità tecnica dell'incarico.
                    </Para>
                    <Para>
                        Il compenso è dovuto <B>oltre IVA, se applicabile</B>, nonché oltre alle spese vive sostenute e documentate a piè di lista (quali, a titolo esemplificativo e non esaustivo, spese di trasferta, viaggio, vitto, alloggio, costi tecnici, strumentali e organizzativi), che il Mandante si impegna a rimborsare integralmente.
                    </Para>
                    <Para>
                        Con la sottoscrizione del presente mandato, <B>il Mandante riconosce sin d'ora come dovuti all'Agenzia i compensi e le spese maturati per l'esecuzione dell'incarico</B> e si impegna irrevocabilmente al relativo pagamento secondo quanto sopra indicato, secondo il tariffario accettato e secondo la documentazione contabile che verrà emessa dall'Agenzia.
                    </Para>

                </View>
                {F(7)}
            </Page>

            {/* Pagina 11 */}
            <Page size="A4" style={pageStyle}>
                {H()}
                <View style={cs}>

                    <Para>
                        La presente clausola costituisce, a tutti gli effetti di legge, <B>promessa di pagamento e ricognizione di debito ai sensi dell'art. 1988 del Codice Civile</B>, con riferimento alle somme che risulteranno dovute per le attività svolte in esecuzione del presente incarico.
                    </Para>
                    <Para>
                        In caso di <B>sospensione, interruzione o recesso dal mandato per causa imputabile al Mandante</B>, ovvero di impossibilità di proseguire le attività per dichiarazioni non veritiere, omissioni o comportamenti del Mandante stesso, <B>restano in ogni caso dovuti all'Agenzia i compensi e le spese maturati sino a quel momento</B>, senza possibilità di eccezioni o contestazioni.
                    </Para>

                    <SectionTitle>DICHIARAZIONI FINALI DEL MANDANTE</SectionTitle>

                    <Para style={{ marginBottom: 2 }}>Con la sottoscrizione del presente mandato, il Mandante:</Para>

                    <BulletItem>
                        (se <B>Persona Fisica</B>) dichiara di aver ricevuto <B>idonea informativa ai sensi degli artt. 13 e 14 del Reg. UE 2016/679</B>;
                    </BulletItem>
                    <BulletItem>
                        dichiara di essere a conoscenza e di accettare che <B>l'obbligazione assunta dall'Agenzia è di mezzi e non di risultato</B> e che <B>qualsiasi eventuale responsabilità è limitata, in ogni caso, all'importo del corrispettivo già pagato</B>;
                    </BulletItem>
                    <BulletItem>
                        prende atto che, qualora il Titolare e/o i collaboratori dell'Agenzia fossero chiamati dall'Autorità Giudiziaria a deporre in qualità di testi, <B>gli onorari e le spese saranno a carico del Mandante</B>, secondo il tariffario ufficiale dell'Agenzia;
                    </BulletItem>
                    <BulletItem>
                        prende atto che, qualora nel corso delle attività emergano elementi in contrasto con quanto dichiarato, <B>l'Agenzia potrà risolvere il contratto e rivalersi per eventuali danni patiti</B>;
                    </BulletItem>
                    <BulletItem>
                        <B>autorizza l'Agenzia ad avvalersi, a proprio insindacabile giudizio, di collaboratori esterni, consulenti e/o istituti corrispondenti</B>, anche esteri;
                    </BulletItem>
                    <BulletItem>
                        <B>si assume ogni responsabilità circa la veridicità delle affermazioni rese</B> in relazione alle finalità dell'incarico.
                    </BulletItem>

                    <SectionTitle>FORO COMPETENTE</SectionTitle>
                    <Para>
                        Per ogni controversia relativa al presente mandato è competente in via esclusiva il <B>Foro della sede dell'Agenzia</B>.
                    </Para>

                    <View style={styles.divider} />

                    <View style={styles.signatureSection}>
                            <Text style={styles.signatureLabel}>Il Mandante</Text>
                        <View style={{ marginBottom: 8, width: '60%', alignSelf: 'flex-start' }} wrap={false}>
                            <View style={styles.signatureArrowRow}>
                                <Text style={styles.signatureArrow}></Text>
                                <View style={styles.signatureLine}>
                                    <Text style={{ fontSize: 0.01, color: '#ffffff' }}>{'#otp_c1#'}</Text>
                                </View>
                            </View>
                        </View>
                    </View>

                </View>
                {F(8)}
            </Page>

        </Document>
    );
};

export default ConsulenzaPDF;
